// extracted by mini-css-extract-plugin
export default {"root":"root--ry7CA","title":"title--PUGZR","content":"content--Lo9VU"};